// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd6cfcc9","732":"0cd78928","977":"059f0129"}[chunkId] + ".chunk.js";
};